import office from '@/taskpane/officejs/office-wrapper'
import MessageArgs from '../messages/message-args'

interface OpenComposeViewArgs extends MessageArgs {
  email: string
  subject: string
}

export default async function openComposeViewHandler(data: OpenComposeViewArgs) {
  try {
    await office.ui.openCompose(data.subject, data.email)
  } catch {
    // no callback
  }
}
